import { IonAccordion, IonAccordionGroup, IonAvatar, IonBackButton, IonButton, IonButtons, IonCard, IonCardContent, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonImg, IonItem, IonLabel, IonMenuButton, IonPage, IonRefresher, IonRefresherContent, IonRow, IonSkeletonText, IonText, IonTitle, IonToolbar, RefresherEventDetail, useIonRouter, useIonViewDidEnter, useIonViewWillEnter } from '@ionic/react';
import React, { useEffect, useRef, useState } from 'react';
import AccountContact from './AccountContact';
import AccountBio from './AccountBio';
import AccountPhotos from './AccountPhotos';
import InitialsAvatar from 'react-initials-avatar';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { cellularOutline, mailOutline, mailUnreadOutline, personCircleOutline, phonePortraitOutline } from 'ionicons/icons';
import { useAppContext } from '../AppProvider';
import { Geolocation, Position } from '@capacitor/geolocation';
import { Capacitor } from '@capacitor/core';
import { Link } from 'react-router-dom';

const Account: React.FC = () => {
    const [memberPhoto1, setMemberPhoto1] = useState<string>('');
    const [photoLoaded, setPhotoLoaded] = useState<boolean>(false);
    const [joinYear, setJoinYear] = useState<number>();
    
    const router = useIonRouter();
    const platform = Capacitor.getPlatform();

    const accordionGroup = useRef<null | HTMLIonAccordionGroupElement>(null);
 
    const memberPhotoPath = '//api.besolowise.com/members/photos/files/'; 

    const { authKey, authenticateMember, authorizedMember, getAuthorizedMember, loading, setShowLoader, level, getLevel, settings, getCountries, getStates, locationPerm, setLocationPerm, textLogoLoaded, fadeInTextLogo, SWFullHorizLogo, SWTextDarkLogo } = useAppContext();   
        
    //
    // Authenticate Member
    //
    useIonViewWillEnter(() => { 
        setShowLoader(true);
        const authenticate = async () => {
            const authenticated = await authenticateMember();  
            if(!authenticated || authenticated.mt == '') router.push('/login', 'forward');
        };
        authenticate();
    }); 

    useEffect(() => {
        const config = async () => {
            // Format Join Year from Join Date
            const joinTime:any = `${authorizedMember.memberJoinDate}`;
            const d = new Date(joinTime*1000);
            const jYear = d.getFullYear();
            setJoinYear(jYear);   
            const date = new Date();
            const time = date.getTime(); 
            setMemberPhoto1(authorizedMember.memberPhoto1ThumbnailUrl);
            
            if (authorizedMember.memberToken !== undefined) getLevel(authorizedMember.memberToken, authorizedMember.memberLevel);

            await getCountries();
            await getStates();
            
            setTimeout(() => setShowLoader(false), 1000);
        }
        config();
                
    }, [authorizedMember]);

    const fadeInPhoto = () => {
        setPhotoLoaded(true);
    };


    const togglePhotosAccordion = () => {        
        if (!accordionGroup.current) return;
        const nativeEl = accordionGroup.current;    
        if (nativeEl.value === 'photos') nativeEl.value = undefined;
        else nativeEl.value = 'photos';
    };

    const accountLevel = (s: string) => {
        switch(s) {
            case '1': return <em>SoloWise Promo</em>
            case '2': return <em>SoloWise Plus</em>
            case '3': return <em>SoloWise Premium</em>
            case '4': return <em>SoloWise Pro 1</em>
            case '5': return <em>SoloWise Pro 2</em>   
            case '6': return <em>SoloWise Platinum</em>      
            default:  return <em>Unknown Plan</em>
        }
    };

    const handleRefresh = (event: CustomEvent<RefresherEventDetail>) => {
        setTimeout(() => {
          getAuthorizedMember(authKey.mt);
          event.detail.complete();
        }, 2000);
    };

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot='start'>
                        <IonBackButton color={'tertiary'}>Back</IonBackButton>
                    </IonButtons>
                    <IonTitle><IonImg className={textLogoLoaded ? 'fade-in' : 'fade-out'} src={settings.theme == '1' ? SWTextDarkLogo : SWFullHorizLogo} onIonImgDidLoad={fadeInTextLogo}></IonImg></IonTitle>
                    <IonButtons slot='end'>
                        <IonMenuButton color={'tertiary'} />
                    </IonButtons>                    
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding account-content-bg" id='AccountContent' fullscreen>

                <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>


                <IonGrid>
                    <IonRow>
                        <IonCol size='12'>
                            <h1>My Profile<br /><span>Manage your personal information </span></h1>
                        </IonCol>
                    </IonRow>

                    <IonRow>
                        <IonCol>                            
                            <IonCard className='greeting'>
                                <IonCardContent>

                                    <IonRow>
                                        <IonCol id="AccountHeader" className='ion-text-center' size='12' sizeSm='5' sizeMd='4' sizeLg='4' sizeXl='3'>
                                            {authorizedMember.memberPhoto1 === ''
                                                    ? (authorizedMember.memberFirstName === '' && authorizedMember.memberLastName === '' 
                                                        ? (<IonAvatar onClick={togglePhotosAccordion}><IonIcon icon={personCircleOutline}></IonIcon></IonAvatar>)  
                                                        : (<InitialsAvatar className='initials-avatar' name={`${authorizedMember.memberFirstName} ${authorizedMember.memberLastName}`} />))
                                                    : (<IonAvatar><IonImg className={photoLoaded ? 'fade-in' : 'fade-out'} src={memberPhoto1} onClick={togglePhotosAccordion} onIonImgDidLoad={fadeInPhoto} /></IonAvatar>)
                                            }
                                        </IonCol>

                                        <IonCol className='account-header-info' size='12' sizeSm='7' sizeMd='5' sizeLg='4' sizeXl='5'> 
                                            <h2>{authorizedMember.memberFirstName} {authorizedMember.memberLastName}</h2>
                                            <p><IonIcon icon={mailOutline} className='ion-margin-end'></IonIcon> {authorizedMember.memberEmail}</p>
                                            {authorizedMember.memberPhone != '' &&
                                            <p><IonIcon icon={phonePortraitOutline} className='ion-margin-end'></IonIcon> {authorizedMember.memberPhone}</p>
                                            }
                                            {/*<p>Member since {joinYear}</p>*/}
                                            <p><span className='member-level'>{level !== null && level.memberLevelName} Member</span></p>
                                        </IonCol>

                                        <IonCol className='button-col' size='12' sizeSm='12' sizeMd='3' sizeLg='4' sizeXl='4'>
                                            <div aria-live="polite" style={{'margin': 'auto 0 0'}}>
                                                <IonButton className='ion-margin' fill='outline' routerLink={`/account/plans`} routerDirection='forward'>Manage My Plan</IonButton>
                                            </div> 
                                        </IonCol>
                                    </IonRow>
                                </IonCardContent>
                            </IonCard>

                            <IonAccordionGroup className='ion-margin-top' ref={accordionGroup}>
                                <IonAccordion value="contact">
                                    <AccountContact />
                                </IonAccordion>
                                <IonAccordion value="biomed">
                                    <AccountBio />
                                </IonAccordion>
                                <IonAccordion value='photos'>
                                    <AccountPhotos getMember={getAuthorizedMember} />
                                </IonAccordion>
                            </IonAccordionGroup>
                        </IonCol>
                    </IonRow>

                </IonGrid>        
            </IonContent>
        </IonPage>
    );
};

export default Account;